module.exports = "<div class=\"required-training\" ng-controller=\"TrainingController as training\">\n    <div ng-include=\"training.currentTopic.templateUrl\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/notificationCenter/modal/training/trainingContent.html
// module id = 765
// module chunks = 1